module.exports = __webpack_public_path__ + "static/media/14febpopup.c0b61cf8.jpg";